import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Switch
} from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'

import {
  fetchAtHomeApartmentCategories,
  setAtHomeApartmentCategory
} from 'api/atHome'
import { Loading } from 'app/components/generic/LottieComponents'

/**
 * Setup → Apartments → "Categories": one switch per category for this
 * apartment. Enforced (owner, 2026-10-01): off = no New session for that
 * pair, no reschedule into it, hidden from parents at this apartment.
 * Default is on. Each flip saves immediately.
 */
const ApartmentCategoriesDialog = ({ apartment, onClose }) => {
  const [rows, setRows] = React.useState(null)
  const [busy, setBusy] = React.useState(null)

  React.useEffect(() => {
    if (!apartment) return
    setRows(null)
    fetchAtHomeApartmentCategories(apartment.uuid)
      .then(setRows)
      .catch(() => setRows([]))
  }, [apartment])

  const flip = async (row) => {
    setBusy(row.category)
    try {
      setRows(
        await setAtHomeApartmentCategory(
          apartment.uuid,
          row.category,
          !row.active
        )
      )
    } catch (error) {
      // toast from request.js
    } finally {
      setBusy(null)
    }
  }

  return (
    <Dialog open={Boolean(apartment)} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Categories at {apartment?.name}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Switch off what this apartment does not offer. Off means no new
          sessions can be listed here for that category and parents at this
          apartment will not see it.
        </DialogContentText>
        {rows === null ? (
          <Loading />
        ) : (
          rows.map((r) => (
            <div key={r.category}>
              <FormControlLabel
                control={
                  <Switch
                    checked={r.active}
                    onChange={() => flip(r)}
                    disabled={busy === r.category}
                    color="primary"
                  />
                }
                label={r.name}
              />
            </div>
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ApartmentCategoriesDialog.propTypes = {
  apartment: PropTypes.object,
  onClose: PropTypes.func.isRequired
}

export default ApartmentCategoriesDialog
